export const modalPicture=

{
    "__typename": "ComponentCommonImage",
    "enabled": true,
    "alt": null,
    "title": "Connect With Our Counsellor\n",
    "url": null,
    "target": null,
    "mobileSource": {
        "__typename": "UploadFileEntityResponse",
        "data": {
            "__typename": "UploadFileEntity",
            "attributes": {
                "__typename": "UploadFile",
                "url": "https://static.amityonline.com/_s/Mobile_banners_new_2025_da84b962ad.webp"
            }
        }
    },
    "source": {
        "__typename": "UploadFileRelationResponseCollection",
        "data": [
            {
                "__typename": "UploadFileEntity",
                "attributes": {
                    "__typename": "UploadFile",
                    "url": "https://static.amityonline.com/_s/2_3_d5821a2212.webp"
                }
            }
        ]
    }
}
